<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/my_company/leaderList"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="user_mobile">
          <Input type="text" v-model="searchData.user_mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>

      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem>
      </template>

    </pageTable>

    <Modal
            v-model="addModal"
            title="添加车队长"
            :loading="loadingAddModal"
            @on-ok="addLeader"
            @on-cancel="addModal=false">
      <Form ref="addForm" :label-width="100" :model="addForm">
        <FormItem label="名字" prop="leader_name">
          <Input v-model="addForm.leader_name" placeholder="" ></Input>
        </FormItem>
        <FormItem label="手机号" prop="leader_mobile">
          <Input v-model="addForm.leader_mobile" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
            v-model="qrcode.isShow"
            @on-cancel="qrcode.isShow=false">
      <img :src="'data:image/png;base64,' + qrcode.imageBase64" v-show="qrcode.imageBase64">
    </Modal>

    <!--<Drawer title="司机列表" width="800"
            :value="showCardSnDrawer"
            :mask-closable="true"
            @on-close="closeCardSn">
        <leaderDriver :card-id="snCardId" v-if="showCardSnDrawer"></leaderDriver>
    </Drawer>-->


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./cardEdit";
  import leaderDriver from "./leaderDriver";
  export default {
    name: "leader",
    components:{pageTable,editForm,leaderDriver},
    data() {
      return {
        showEditForm:false,
        editCardId:0,
        searchData: {
          user_mobile: '',
          company_id:'',
          create_time:''
        },
        qrcode:{
          isShow:false,
          imageBase64:'',
        },
        tableColumn: [
          {title: '姓名',key: 'leader_name',align: "center"},
          {title: '手机号',key: 'leader_mobile',align: "center"},
          {title: '司机人数',key: 'driver_num',align: "center"},
          {title: '可注册司机数',key: 'max_driver_num',align: "center",render:(h,params)=>{
              return h('div',[
                h('Input',{
                  style:{width:'60px',marginRight:'5px'},
                  props:{value:params.row.max_driver_num,size:'small'},
                  on:{
                    input:(val)=>{
                      this.$set(params.row,'max_driver_num',val)
                    }
                  }
                }),
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  on: {click: () => {this.editMaxDriverNum(params.row)}}
                },'修改')
              ])
            }},
          {title: '二维码',align: "center",render:(h,params)=>{
              return h('Button',{
                props: {type: 'primary', size: 'small'},
                style:{marginLeft:'5px'},
                on: {click: () => {this.showCardQrcode(params.row.leader_id)}}
              },'二维码')
            }},
          {title: '操作',align: "center",render:(h,params)=>{
              return h('div',[
               /* h('Button',{
                  props: {type: 'primary', size: 'small'},
                  style:{marginLeft:'5px'},
                  on: {click: () => {this.showRecharge(params.row)}}
                }, '查看司机'),*/
                h('Button',{
                  props: {type: 'error', size: 'small'},
                  style:{marginLeft:'5px'},
                  on: {click: () => {this.delLeader(params.row)}}
                }, '删除'),
              ])
            }},
        ],
        tableData: [],

        addModal:false,
        loadingAddModal:true,
        addForm:{
          leader_name:'',
          leader_mobile:'',
        },

      }
    },
    methods: {
      cancelEdit(){
        this.showEditForm = false
        this.editCardId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEditForm = false
        this.editCardId = 0
      },
      edit(){
        this.addModal = true
      },

      async addLeader(){
        let res = await this.$commonFun.postProxy('admin/my_company/addLeader',this.addForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.addModal = false
            this.$refs.table.getLists();
          })
        })
      },

      async editMaxDriverNum(info){
        let res = await this.$commonFun.postProxy('admin/my_company/editMaxDriverNum',{leader_id:info.leader_id,max_driver_num:info.max_driver_num});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.addModal = false
            this.$refs.table.getLists();
          })
        })
      },

      async delLeader(info){
        this.$Modal.confirm({
          title:'删除车队长',
          content:'确定要删除吗？',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/my_company/delLeader',{leader_id:info.leader_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$refs.table.getLists();
              this.$commonFun.successTip(res.msg,()=>{
              })
            })
          }
        })
      },
      async showCardQrcode(leader_id){
        let res = await this.$commonFun.postProxy('admin/mini_code/cardQrcode',{leader_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.qrcode.isShow = true
          this.qrcode.imageBase64 = res.data
          // this.draw();
        })
      }

    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>
